module.exports = __webpack_public_path__ + "assets/img/simfoni-icon.0ef21d7b.png";